import { CourseWithChapters } from "@jelly/lesson";
import { formatLessonsForChapter } from "../../../services/Utils";
import lesson01 from "../../lesson/course-01/lesson-01/lesson";
import lesson02 from "../../lesson/course-01/lesson-02/lesson";
import lesson03 from "../../lesson/course-01/lesson-03/lesson";
import lesson04 from "../../lesson/course-01/lesson-04/lesson";
import lesson05 from "../../lesson/course-01/lesson-05/lesson";
import lesson06 from "../../lesson/course-01/lesson-06/lesson";
import lesson07 from "../../lesson/course-01/lesson-07/lesson";
import lesson08 from "../../lesson/course-01/lesson-08/lesson";
import lesson09 from "../../lesson/course-01/lesson-09/lesson";
import lesson10 from "../../lesson/course-01/lesson-10/lesson";
import lesson11 from "../../lesson/course-01/lesson-11/lesson";
import lesson12 from "../../lesson/course-01/lesson-12/lesson";
import lesson13 from "../../lesson/course-01/lesson-13/lesson";
import lesson14 from "../../lesson/course-01/lesson-14/lesson";
import lesson15 from "../../lesson/course-01/lesson-15/lesson";
import lesson16 from "../../lesson/course-01/lesson-16/lesson";
import lesson17 from "../../lesson/course-01/lesson-17/lesson";
import lesson18 from "../../lesson/course-01/lesson-18/lesson";
import lesson19 from "../../lesson/course-01/lesson-19/lesson";
import lesson20 from "../../lesson/course-01/lesson-20/lesson";
import lesson21 from "../../lesson/course-01/lesson-21/lesson";
import lesson22 from "../../lesson/course-01/lesson-22/lesson";
import lesson23 from "../../lesson/course-01/lesson-23/lesson";
import lesson24 from "../../lesson/course-01/lesson-24/lesson";
import lesson25 from "../../lesson/course-01/lesson-25/lesson";
import lesson26 from "../../lesson/course-01/lesson-26/lesson";
import lesson27 from "../../lesson/course-01/lesson-27/lesson";
import lesson28 from "../../lesson/course-01/lesson-28/lesson";
import lesson29 from "../../lesson/course-01/lesson-29/lesson";
import lesson30 from "../../lesson/course-01/lesson-30/lesson";
import case01 from "../../lesson/course-01/case-01/case";
import case02 from "../../lesson/course-01/case-02/case";
import authorMv from "./authors/author-mv";
import authorJpd from "./authors/author-jpd";
import authorSr from "./authors/author-sr";
import authorRpv from "./authors/author-rpv";

/* eslint-disable max-len */
const data: CourseWithChapters = {
  id: "41545ab2-1f99-40ea-8225-21d5e62ab7b0",
  publicId: "1",
  slug: "acoustic-fundamentals",
  name: "Acoustic Fundamentals",
  description:
    "This is an online course of 30 interactive lessons on acoustic fundamentals with two case studies for practical application. The aim of the course is to provide the basic concepts and mathematical models needed to approach various applications in acoustics. Most lessons can be considered as prerequisites for the other chapters. The first lessons (1-9) are devoted to 1D wave propagation. Then, more mathematically demanding lessons about 3D waves (10-17) follow. Four lessons (18-21) focus on the question of boundary conditions and their connection to the concept of modes of waveguides or cavities. Lessons 22 to 30 explore complementary but important notions that did not fit into the linear progression of the first 21 courses. Alongside each lesson, there are illustrations, animations, applets, or sounds provided to give a tangible dimension to the concepts developed in the course. Finally, two case studies demonstrate how the basic knowledge can be applied to measure the acoustic properties of materials (case study 1) or the sound attenuation index (case study 2).",
  shortDescription:
    "This is an online course of 30 interactive lessons on acoustic fundamentals with two case studies for practical application.",
  chapters: [
    {
      id: "249caf83-6be8-4ba3-92ed-316d1fbc169b",
      name: "Basics on sound and waves / 1D acoustics (tubes)",
      position: 0,
      chapterLessons: formatLessonsForChapter([
        lesson01,
        lesson02,
        lesson03,
        lesson04,
        lesson05,
        lesson06,
        lesson07,
        lesson08,
        lesson09,
      ]),
    },
    {
      id: "fe604036-c6b8-4ee2-9183-d4d9c00f079c",
      name: "3D waves and sources",
      position: 1,
      chapterLessons: formatLessonsForChapter(
        [lesson10, lesson11, lesson12, lesson13, lesson14, lesson15, lesson16, lesson17],
        10
      ),
    },
    {
      id: "f76a0203-29cf-4744-9caa-c5406c3399f1",
      name: "Waveguides and Cavities",
      position: 2,
      chapterLessons: formatLessonsForChapter([lesson18, lesson19, lesson20, lesson21], 17),
    },
    {
      id: "46564ec5-1eb0-47d5-8ee3-89d2f56c4c8e",
      name: "Zooms",
      position: 3,
      chapterLessons: formatLessonsForChapter(
        [lesson22, lesson23, lesson24, lesson25, lesson26, lesson27, lesson28, lesson29, lesson30],
        21
      ),
    },
    {
      id: "d3b8b424-391c-4132-b1a3-47c63ba95007",
      name: "Case studies",
      position: 4,
      chapterLessons: formatLessonsForChapter([case01, case02], 30),
    },
  ],
  authors: [authorJpd, authorSr, authorMv, authorRpv],
  authorsDescription: "",
};
/* eslint-enable max-len */

export default data;
